export enum ActiveRoute {
  STORE = 'store',
  LOBBY = 'lobby',
  FAST = 'fast',
  CLASSIC = 'classic',
  INITIAL = 'none',
}
